import script from "./createReport.vue?vue&type=script&setup=true&lang=js"
export * from "./createReport.vue?vue&type=script&setup=true&lang=js"

import "./createReport.vue?vue&type=style&index=0&id=0bc96aea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc96aea"]])

export default __exports__